import { db } from './../db';
const sessions = db.collection('sessions');

export const SESSION_ACTION = {
	methods: {
		sessionSave(){
			if ( this.session.uuid && this.session.uuid.length ){
				this.$firestoreRefs.session.update(this.session).then(() => {
					this.$notify({
						group: 'system',
						type: 'success',
						title: 'Great!',
						text: 'Session has been updated!'
					});
				})
			} else {
				this.session.uuid = this.$uuid.v1();
				sessions.add(this.session).then(() => {
					this.$notify({
						group: 'system',
						type: 'success',
						title: 'Great!',
						text: 'Session has been created!'
					});
					this.$router.push({name: 'sessionsList'});
				})
			}
		},
		sessionDelete(){
			this.$firestoreRefs.session.delete().then(() => {
				this.$router.push({name: 'sessionsList'});
				this.$notify({
					group: 'system',
					type: 'success',
					title: 'Great!',
					text: 'Session has been removed!'
				});
			})
		},
	}
};

export const IMPORT_DATA = {
	methods:{
		async fetchData(type, query) {
			let url;
			let term = query ? query : this.query;
			switch (type) {
				case 'user':
					url = `/content/users/${term}.json`;
					break;
				case 'sessions':
					url = `/content/sessions/index.json`;
					break;
				case 'sections':
					url = `/content/sections/index.json`;
					break;
			}
			return new Promise(resolve => {
				fetch(url)
					.then(r => r.json())
					.then(resp => resolve(resp))
			})
		},
		async fetchContent(file, dir) {
			return new Promise(resolve => {
				fetch(`/content/${dir}/${file}`)
					.then(response => response.text())
					.then(result => resolve(result));
			})
		},
	}
};
